import { fetchJson } from 'utils/fetch';

export const getMaterialTypes = type =>
  fetchJson(`/products/materials.json?task_type=${type}`);

export const getReferenceUses = ref =>
  fetchJson(`/admin/refs/${ref}/uses.json`);



// WEBPACK FOOTER //
// ./src/modules/product/api/index.js